<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-6">
                  <pr-input-column
                    label="Cotisation"
                    [derrors]="derrors"
                    [suffix]="'€'"
                  >
                    <input
                      formControlName="monthlyPayment"
                      type="text"
                      placeholder="0"
                    />
                  </pr-input-column>
                </div>
                <div class="col-md-6">
                  <pr-input-column
                    label="Periodicite de cotisation"
                    [derrors]="derrors"
                  >
                    <pr-select-search
                      formControlName="cotisationPeriode"
                      label="Periodicite de cotisation"
                      [options]="cotisationPeriodeOptions"
                      optionDisplayKey="label"
                    >
                    </pr-select-search>
                  </pr-input-column>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
                  <pr-input-date
                    formControlName="effectiveDate"
                    label="Date de début de couverture"
                    [derrors]="derrors"
                  ></pr-input-date>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
